import React from 'react'
import styled from 'styled-components'
import { RADOM_COLORS } from '../util/Constants'
import { PrimaryButton } from './Button'

const Wrapper = styled.div<{ fullPage?: boolean }>`
  width: 100%;
  min-width: ${({ fullPage = true }) => (fullPage ? '100vw' : '100%')};
  min-height: ${({ fullPage = true }) => (fullPage ? '100vh' : '220px')};
  display: flex;
  align-items: ${({ fullPage = true }) => (fullPage ? 'flex-start' : 'center')};
  justify-content: center;
  padding: ${({ fullPage = true }) => (fullPage ? '64px 24px 24px' : '24px 0')};
  box-sizing: border-box;
  background: transparent;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  max-width: 560px;
  text-align: center;
  color: #111827;
`

const Title = styled.h2`
  margin: 0;
  font-size: 22px;
  line-height: 1.2;
  font-weight: 600;
  color: ${RADOM_COLORS.BLACK};
`

const Message = styled.p`
  margin: 0;
  font-size: 15px;
  line-height: 1.5;
  color: #4b5565;
`

interface IProps {
  title?: string
  message: string
  fullPage?: boolean
  onRetry?: () => void | Promise<void>
  retryLabel?: string
}

const PageLoadState = ({
  title = 'Unable to load page',
  message,
  fullPage = true,
  onRetry,
  retryLabel = 'Retry'
}: IProps): React.ReactElement => {
  return (
    <Wrapper fullPage={fullPage}>
      <Content>
        <Title>{title}</Title>
        <Message>{message}</Message>
        {onRetry && (
          <PrimaryButton
            onClick={() => {
              void onRetry()
            }}
            style={{
              minWidth: 132,
              marginTop: 6,
              borderRadius: 12
            }}
          >
            {retryLabel}
          </PrimaryButton>
        )}
      </Content>
    </Wrapper>
  )
}

export default PageLoadState
